import { ClubSlug } from '@/fairplayer/domain/club/ClubSlug';
import { Operation } from '@/fairplayer/domain/operation/Operation';
import { InjectionKey } from 'vue';

export const operationRepositoryKey: InjectionKey<OperationRepository> = Symbol();

export interface OperationRepository {
  list(clubSlug: ClubSlug): Promise<Operation[]>;
}
